module.exports = "/packs/media/modules/shared/components/Cookies/sections/analytics-e669129136751263f4f5b04d6e8ae415.svg";